__turbopack_context__.v({
  "map": "AfricaMap-module-scss-module__1TXdBa__map",
});
